<template>
  <div class="p-8 bg-gray-50 rounded-lg shadow" style="text-align: center;">
    <h1 class="text-2xl font-bold mb-6">개인정보 수집 및 이용 동의서</h1>

    <div class="text-base leading-relaxed space-y-6">
      <div class="mb-8">
        <p>팀페이버드(이하 "회사")는 개인정보 보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법령상의 개인정보보호 규정을 준수하며, 개인정보 보호에 최선을 다하고 있습니다.</p>
        <p class="mt-2">회사는 추첨된 로또 번호를 발송하기 위한 목적으로 필요 최소한의 개인정보를 수집하고 있으며 아래 내용에서 상세한 내용을 확인 해주시기 바랍니다.</p>
      </div>

      <section class="mb-8">
        <h2 class="text-lg font-bold mb-4">■ 개인정보의 수집·이용 목적</h2>
        <ul class="space-y-2">
          <li>- 앱 이용자는 추첨된 로또번호를 회원의 메일이나 휴대전화 문자로 전송할 수 있습니다.</li>
          <li>- 회사는 가입 시 수집한 정보를 로또번호 송출에 사용하게 됩니다.</li>
          <li>- 또한, 고객 대응, 환불 등의 절차를 위한 목적으로 사용합니다.</li>
          <li class="mt-2">이용자가 제공한 정보는 하기 목적에 필요한 용도 이외로는 사용되지 않습니다.</li>
          <li>- 유료 서비스 제공에 따른 본인인증, 구매 및 요금 결제 등의 목적으로 이용합니다.</li>
          <li>- 법령 및 서비스 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용 행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위에 대한 방지 및 제재 등과 같은 민원처리 등 이용자 보호 및 서비스 운영 등의 목적으로 이용합니다.</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-lg font-bold mb-4">■ 개인정보의 수집 항목 및 방법</h2>
        <ul class="space-y-2">
          <li>- 회사는 모든 이용자에게 더 나은 서비스를 제공하기 위해 이용자의 기본정보 외에는 수집하지 않습니다.</li>
          <li>- 회원가입 시에는 계정 생성을 위해 이메일을 수집하며, 생성된 번호를 메일로 발송하기 위해 필수 항목으로 수집합니다.</li>
          <li>- 생성된 번호를 문자로 전송하기 위해 휴대전화 번호를 수집합니다.</li>
          <li>- 서비스 사용 중 장애에 대처하기 위해서 IP 주소, 방문 일시, 쿠키, 서비스 사용기록, 오류 사용 기록, 접속 디바이스 정보, 사용 브라우저 정보 등이 생성되어 수집될 수 있습니다.</li>
          <li class="mt-2">구체적으로 서비스 사용과정에서 이용자에 관한 정보를 정보통신서비스 제공자가 자동화된 방법으로 생성하여 이를 저장(수집)하거나, 이용자 기기의 고유한 정보를 원래의 값을 확인하지 못하도록 안전하게 변환한 후에 수집하게 됩니다.</li>
          <li class="mt-2">개인정보를 수집하는 방법은 아래와 같습니다.</li>
          <li>- 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우</li>
          <li>- 고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등을 통하는 경우</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-lg font-bold mb-4">■ 개인정보의 보유 및 이용 기간</h2>
        <p>회사는 회원 탈퇴, 보유 및 이용 기간 종료 시 해당 개인정보를 지체 없이 파기합니다.</p>
        <p class="mt-2">단, 다음의 정보에 대해서는 관련 법령에 따라 명시한 기간에 별도로 분리 보관되며, 명시한 기간이 경과한 개인정보는 지체없이 파기합니다.</p>
        <ul class="space-y-2 mt-4">
          <li>- 관련 법령에 의한 정보보유 사유</li>
          <li>- 전자상거래 등에서 소비자 보호에 관한 법률</li>
          <li class="ml-4">계약 또는 청약철회 등에 관한 기록: 5년 보관</li>
          <li class="ml-4">대금결제 및 재화 등의 공급에 관한 기록: 5년 보관</li>
          <li class="ml-4">소비자의 불만 또는 분쟁처리에 관한 기록: 3년 보관</li>
          <li>- 통신비밀보호법</li>
          <li class="ml-4">로그인 기록: 3개월 보관</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-lg font-bold mb-4">■ 개인정보의 제3자 제공</h2>
        <p>회사는 기본적으로 개인 정보를 제3자에게 제공하지 않습니다.</p>
        <p class="mt-2">이용자의 사전 동의 없이는 본래의 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다.</p>
        <p class="mt-2">단, 다음의 경우에는 개인정보를 처리할 수 있습니다.</p>
        <ul class="mt-2">
          <li>- 법령 등에 의해 제공이 요구되는 경우</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-lg font-bold mb-4">■ 개인정보의 파기 및 장기 미용자의 개인정보 분리 보관</h2>
        <ul class="space-y-2">
          <li>- 회사는 개인정보의 보유 및 이용 기간이 경과하거나, 수집 및 이용 목적이 달성되면 지체 없이 개인정보를 파기합니다. 다만, 회사는 "다른 법령에 따라 보존하여야 하는 경우"에는 보유 및 이용 기간이 경과한 개인정보를 파기하지 아니하고 보존할 수 있습니다.</li>
          <li>- 종이에 출력된 개인정보는 분쇄기로 분쇄 또는 소각하여 파기하고, 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
          <li>- 회사는 개인정보의 기술적•관리적 보호를 위해 다음과 같은 조치를 취하고 있습니다.</li>
          <li class="ml-4">관리적 조치: 내부관리계획 수립∙시행, 직원에 대한 정기적 교육</li>
          <li class="ml-4">기술적 조치: 개인정보처리시스템(또는 개인정보가 저장된 컴퓨터)의 비밀번호 설정 등 접근권한 관리, 백신소프트웨어 등 보안프로그램 설치, 개인정보가 저장된 파일의 암호화</li>
          <li class="ml-4">물리적 조치: 개인정보가 저장∙보관된 장소의 시건, 출입통제 등</li>
          <li>- 회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제29조 및 동법 시행령 제16조에 의거하여 휴면 회원의 개인정보를 접근 불가능한 별도의 장치에 분리 보관합니다.</li>
          <li>- 휴면 회원은 서비스를 1년이상 사용하지 않은 경우에 해당됩니다. 회사는 휴면 전환 30일 전까지 휴면 예정 회원에게 별도 분리 보관되는 사실 및 휴면 예정일, 별도 분리 보관하는 개인정보 항목을 이메일, 문자 등 어느 하나의 방법으로 이용자에게 알립니다.</li>
          <li>- 휴면 회원이 서비스 홈페이지 로그인 등 서비스를 재이용하는 경우 휴면계정은 일반 회원 계정으로 복구됩니다.</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-lg font-bold mb-4">■ 동의거부권 및 동의거부시 불이익 공지</h2>
        <p>회사는 이용자에게 개별적인 맞춤 서비스를 제공하고 부정 사용 방지 및 안전한 인터넷 거래 환경 보장을 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.</p>
        <p class="mt-2">쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.</p>
        <ul class="space-y-2 mt-4">
          <li>- 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다. 또한 다른 선량한 이용자의 보호를 위해 부정기록이용을 파악하여 부정가입 및 사용 방지하는데 사용됩니다.</li>
          <li>- 쿠키의 설치∙운영 및 거부: 웹브라우저 상단의 도구 인터넷 옵션 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</li>
        </ul>
        <p class="mt-4">귀하는 본 동의서에 따른 개인정보 제공에 대하여 거부할 권리가 있습니다.</p>
        <p class="mt-2">다만, 동의를 거부하는 경우에는 본 서비스 이용이 불가 합니다.</p>
        <p class="mt-2">회사의 위와 같은 개인정보 수집 및 이용에 동의하지 않으시면 앱을 닫고 삭제하면 됩니다.</p>
        <p class="mt-2">만약, 회원가입과 사용을 진행한다면 이에 대해 동의한 것으로 간주됩니다.</p>
      </section>

      <section>
        <h2 class="text-lg font-bold mb-4">■ 개인정보 보호책임자</h2>
        <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체(이용자)의 불만처리 및 피해구제를 처리하기 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
        <ul class="mt-4 space-y-1">
          <li>성명 : 장형준</li>
          <li>직책 : 개발팀장</li>
          <li>연락처 : hello@numberfavored.io</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
</style>
  